export function validMobileNetworks(startsWith) {
  const validNetworks = ['010', '011', '012', '013', '014', '015', '016', '017', '018', '019'];

  return validNetworks.find((f) => f === startsWith?.toString().trim());
}
